export default __webpack_public_path__ + "static/media/content_copy_blue.6ceaebc2.svg";